import work_surprise from './work_surprise';
import restuarant_problem from './restuarant_problem';
import vacation from './vacation';

const letters_ml = [];
letters_ml.push({ name: 'Work Surprise', content:work_surprise });
letters_ml.push({ name: 'Restuarant Problem', content:restuarant_problem });
letters_ml.push({ name: 'Vacation Friend', content:vacation });

export default letters_ml;